/* istanbul ignore file */

export const HEADING = 'What customers think';

export const AI_SUMMARY_NOTE = 'AI summary of reviews';

export const MOST_LOVED_PREFIX = 'This is one of our customers’';
export const MOST_LOVED_LABEL = 'Most Loved';
export const MOST_LOVED_SUFFIX = 'products';

/** @public Used by the as-advertised line commented out in ReviewsSummary (DISC-4730) */
export const AS_ADVERTISED_SUFFIX = 'say this product is as advertised';
